import { forwardRef } from 'react';
import { cn } from '../utils/cn';

// =============================================================================
// AssistantFab — floating entry point for the schedule assistant.
//
// Bottom-right, offset by the device safe area (and above the phone bottom tab
// bar). A 56px round button showing only the white BRICK lit mark; the name
// lives in aria-label. When the panel is open it slides left to sit
// beside the 400px panel on md+; on narrow screens the panel is a full-screen
// sheet with its own ✕, so the FAB hides. z-40 keeps it under modals (z-50+),
// whose sticky footers sit in the same bottom-right corner.
// =============================================================================

export const ASSISTANT_PANEL_ID = 'assistant-panel';

export const AssistantFab = forwardRef<HTMLButtonElement, { open: boolean; onToggle: () => void }>(function AssistantFab({ open, onToggle }, ref) {
  return (
    <button
      ref={ref}
      type="button"
      onClick={onToggle}
      aria-label={open ? '어시스턴트 닫기' : '어시스턴트 열기'}
      aria-pressed={open}
      aria-expanded={open}
      aria-controls={ASSISTANT_PANEL_ID}
      data-testid="assistant-fab"
      className={cn(
        'fixed z-40 flex h-14 w-14 items-center justify-center rounded-full shadow-lg',
        'bottom-[max(1rem,env(safe-area-inset-bottom))] right-[max(1rem,env(safe-area-inset-right))]',
        // 모바일 하단 탭바(약 56px) 위로 올린다.
        'max-md:bottom-[calc(4.5rem+env(safe-area-inset-bottom))] max-md:right-3',
        'transition-all duration-fast ease-snap focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent',
        open
          ? 'hidden md:flex md:right-[calc(400px+max(1rem,env(safe-area-inset-right)))] bg-panel border border-line-strong text-text'
          : 'bg-accent-solid text-white hover:bg-accent-solid-hover',
      )}
    >
      {/* BRICK lit 심볼(resources/logo_simbol.svg). currentColor라 빨간 버튼 위에선 white. */}
      <svg aria-hidden="true" viewBox="0 0 112 120" width={21} height={22} fill="currentColor">
        <path d="M111.477 28.8545C111.423 28.8542 111.367 28.8525 111.312 28.8525C94.0762 28.8526 80.1037 42.8253 80.1035 60.0615C80.1035 77.2979 94.0761 91.2715 111.312 91.2715C111.367 91.2715 111.423 91.2688 111.477 91.2686V119.437H59.1005V0H111.477V28.8545Z" />
        <path d="M0 28.8545C0.0549583 28.8542 0.110012 28.8525 0.165039 28.8525C17.4013 28.8525 31.3738 42.8253 31.374 60.0615C31.374 77.2979 17.4014 91.2715 0.165039 91.2715C0.110012 91.2715 0.0549583 91.2688 0 91.2686V119.437H52.377V0H0V28.8545Z" />
      </svg>
    </button>
  );
});
